/** Background slugs used by CrosshairCanvas (CSS classes + preview images). */
export const CROSSHAIR_BACKGROUND_IDS = [
    "default",
    "blue-wall",
    "green-box",
    "haven-wall",
    "red-wall",
    "gray-wall",
    "blue-container",
    "split-wall",
    "yellow-container",
    "grass",
    "sky",
    "shower",
] as const;

export type CrosshairBackgroundId = (typeof CROSSHAIR_BACKGROUND_IDS)[number];

const LABELS: Record<CrosshairBackgroundId, string> = {
    default: "Default",
    "blue-wall": "Blue wall",
    "green-box": "Green box",
    "haven-wall": "Haven wall",
    "red-wall": "Red wall",
    "gray-wall": "Gray wall",
    "blue-container": "Blue container",
    "split-wall": "Split wall",
    "yellow-container": "Yellow container",
    grass: "Grass",
    sky: "Sky",
    shower: "Shower",
};

export function crosshairBackgroundLabel(id: CrosshairBackgroundId): string {
    return LABELS[id];
}
